const state = {
    isAllowed: 0,
}

const getters = {
    isAllowed(state) {
        return state.isAllowed
    },
}

const mutations = {
    setIsAllowed(state, isAllowed) {
        state.isAllowed = isAllowed
    }
}

const actions = {
    setIsAllowed({ commit }, isAllowed) {
        commit('setIsAllowed', isAllowed)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
